module.exports = __webpack_public_path__ + "static/img/image8.5973080.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instruction_images/image8.png
// module id = hSrF
// module chunks = 0